const re = new RegExp(/^\+1[0-9]{10}$/);

const validPhoneNumber = (phoneNumber) => {
    if(!re.test(phoneNumber)){
        return("Enter valid phone number")
    }
}

export default validPhoneNumber;